// ═══════════════════════════════════════════════════════════════════════════════
// Pairing Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { PAIRING_CODE_LENGTH } from '../constants/index.js';
const pairingCodeValueSchema = z
    .string()
    .trim()
    .toUpperCase()
    .length(PAIRING_CODE_LENGTH, `Pairing code must be ${PAIRING_CODE_LENGTH} characters`)
    .regex(/^[A-Z0-9]+$/, 'Pairing code must contain only uppercase letters and numbers');
// ── Join Pairing Input Schema ──
export const joinPairingInputSchema = z.object({
    code: pairingCodeValueSchema,
});
// ── Public pairing code preview ──
export const pairingCodePreviewInputSchema = z.object({
    code: pairingCodeValueSchema,
});
export const pairingCodePreviewResponseSchema = z.object({
    valid: z.boolean(),
    employerNickname: z.string().optional(),
    expiresAt: z.string().optional(),
    reason: z.string().optional(),
});
export const activePairingCodeResponseSchema = z.object({
    code: z.string().length(PAIRING_CODE_LENGTH).nullable(),
    expiresAt: z.string().nullable(),
});
// ── Generate Pairing Code Response Schema ──
export const generatePairingCodeResponseSchema = z.object({
    code: z.string().length(PAIRING_CODE_LENGTH),
    expiresAt: z.string(),
});
//# sourceMappingURL=pairing.schema.js.map